// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__HcifE","emails":"CreateEditClinics_emails__3YAFp","emailTagLabel":"CreateEditClinics_emailTagLabel__3NAmW"};